// @flow

import styled from 'styled-components';
import {
  BORDER_WIDTH,
  BOX_SHADOW,
  COLORS,
  LETTER_SPACING,
  SPACING,
  TYPE_SCALE,
  Z_INDEX,
  FONT_WEIGHT,
  MEDIA,
} from 'clark-styles';

const { BS_SMALL } = BOX_SHADOW;
const { GREY_10, GREY_100, WHITE } = COLORS;
const { LS_2_5 } = LETTER_SPACING;
const { S_1, S_2 } = SPACING;
const { BW_1 } = BORDER_WIDTH;
const { TS_6 } = TYPE_SCALE;
const { FW_100 } = FONT_WEIGHT;
const { Z_TOP } = Z_INDEX;
const S_1_5 = '1.5rem';

export const Wrap = styled.div`
  position: relative;
  width: 100%;
`;

export const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  content: '';
  z-index: 4;

  ${MEDIA.small`
    display: none;
  `}
`;

export const Menu = styled.div`
  background-color: ${WHITE};
  ${BS_SMALL};
  display: ${({ menuOpen }) => (menuOpen ? 'block' : 'none')};
  left: 0;
  right: 0;
  top: 0;
  position: fixed;
  text-align: right;
  ${Z_TOP};

  ${MEDIA.small`
    position: absolute;
    right: -${S_1_5};
  `}
`;

export const MenuItems = styled.ul`
  list-style-type: none;
  padding: 0 ${S_1_5};
`;

export const MenuItem = styled.li`
  list-style-type: none;
  margin: ${S_2} 0;
`;

export const MenuItemLink = styled.a`
  cursor: pointer;
  color: ${GREY_100};
  ${TS_6};
  ${LS_2_5};
  text-decoration: none;
  text-transform: uppercase;

  ${({ small }) =>
    small &&
    `
    ${FW_100};
    text-transform: none;
  `}
`;

export const RightMargin = styled.span`
  margin-right: ${S_1};
`;

export const SettingsCtaWrapper = styled.div`
  display: 'flex';
  justify-content: 'flex-end';
  padding: 0;

  ${({ isOpen }) =>
    isOpen &&
    `
    padding: ${`${S_2} ${S_1_5}`};
    border-bottom: solid ${GREY_10} ${BW_1};
  `};

  ${MEDIA.small`
    padding: ${S_1} 0 0;
    ${({ isOpen }) =>
      isOpen &&
      `
      padding: ${S_1} ${S_1_5};
      border-bottom: solid ${GREY_10} ${BW_1};
    `};
  `}
`;



// WEBPACK FOOTER //
// ./src/containers/settings-dropdown/styles.js